import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Wrapper = styled.div`
  width: 83%;
  margin: 0 auto 80px;
  @media (max-width: 575.98px) {
    width: 90%;
    margin: 0 auto 60px;
  }
  @media (min-width: 576px) and (max-width: 834px) {
    margin: 0 auto 50px;
  }
  @media (min-width: 835px) and (max-width: 1280px) {
    margin: 0 auto 70px;
  }
  @media (min-width: 1441px) {
    width: 77%;
  }
`;

const Title = styled.h2`
  text-align: right;
  font-family: "Almoni";
  font-weight: 500;
  line-height: 27.188px;
  margin: 0 0 52px;
  color: #583715;
  @media (max-width: 575.98px) {
    font-size: 22px;
    margin: 0 0 30px;
  }
  @media (min-width: 576px) and (max-width: 834px) {
    font-size: 22px;
    margin: 0 0 35px;
  }
  @media (min-width: 835px) and (max-width: 1280px) {
    font-size: 24px;
    margin: 0 0 40px;
  }
  @media (min-width: 1281px) and (max-width: 1440px) {
    font-size: 28px;
    margin: 0 0 45px;
  }
  @media (min-width: 1441px) {
    font-size: 32px;
    margin: 0 0 54px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px 30px;
  @media (max-width: 575.98px) {
    grid-template-columns: 1fr;
    gap: 25px;
  }
  @media (min-width: 576px) and (max-width: 834px) {
    gap: 30px 20px;
  }
  @media (min-width: 1441px) {
    gap: 50px 40px;
  }
`;

const ProjectCard = styled(Link)`
  text-decoration: none;
  display: block;
  cursor: pointer;
  transition: transform 0.3s ease;
  &:hover {
    transform: scale(1.02);
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 4px;
  @media (max-width: 575.98px) {
    width: 85%;
    margin: 0 auto;
  }
`;

const ProjectImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ProjectInfo = styled.div`
  text-align: right;
  margin-top: 12px;
  color: #583715;
  font-family: "Almoni";
  font-weight: 400;
  font-size: 16px;
  @media (max-width: 575.98px) {
    font-size: 14px;
    margin-top: 10px;
    width: 85%;
    margin-left: auto;
    margin-right: auto;
  }
  @media (min-width: 1281px) and (max-width: 1440px) {
    font-size: 18px;
  }
  @media (min-width: 1441px) {
    font-size: 20px;
    margin-top: 15px;
  }
`;

const ProjectName = styled.span`
  color: #583715;
`;

const ProjectLocation = styled.span`
  color: rgba(88, 55, 21, 0.6);
  &::before {
    content: " | ";
    color: rgba(88, 55, 21, 0.6);
  }
`;

const ProjectsGallery = ({ projects, title }) => {
  return (
    <Wrapper>
      <Title>{title}</Title>
      <Grid>
        {projects.map((project) => (
          <ProjectCard key={project.id} to={project.link || "#"}>
            <ImageContainer>
              <ProjectImage src={project.image} alt={project.title} />
            </ImageContainer>
            <ProjectInfo>
              <ProjectName>{project.title}</ProjectName>
              <ProjectLocation>{project.location}</ProjectLocation>
            </ProjectInfo>
          </ProjectCard>
        ))}
      </Grid>
    </Wrapper>
  );
};

export default ProjectsGallery;
